"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderItemsChangeSchema = exports.OrderItemChangeSchema = exports.OrderItemSchema = void 0;
const zod_1 = require("zod");
const __1 = require("..");
exports.OrderItemSchema = zod_1.z.object({
    condition: zod_1.z.nativeEnum(__1.ItemCondition).optional(),
    isGift: zod_1.z.boolean().optional(),
    item: __1.ItemSchema.partial().required({ id: true }).optional(),
    /**
     * @description An order item can have multiple offers, for example,
     *  if the item has multiple variants. This fields store the item id given
     *  by the channel where the order was originated, so that it's possible
     *  to find it on the RediRedi item model.
     * @see {@link IItemOffer}
     */
    channelItemOfferId: __1.ShortStringSchema,
    channelItemVariantOfferId: __1.ShortStringSchema,
    itemId: __1.ShortStringSchema.optional(),
    variantId: __1.ShortStringSchema.optional(),
    /**
     * That's the price paid by the buyer for the item. if has a active promotion is promotion price.
     */
    itemPrice: __1.MoneySchema.optional(),
    itemDiscount: __1.MoneySchema.optional(),
    /**
     * That's is item variant price without promotion price
     */
    itemRegularPrice: __1.MoneySchema.optional(),
    itemTax: __1.MoneySchema.optional(),
    promotionDiscount: __1.MoneySchema.optional(),
    promotionDiscountTax: __1.MoneySchema.optional(),
    quantityOrdered: zod_1.z.number().nonnegative().int(),
    quantityShipped: zod_1.z.number().nonnegative().int().optional(),
    saleFee: __1.MoneySchema.optional(),
    shippingDiscount: __1.MoneySchema.optional(),
    shippingDiscountTax: __1.MoneySchema.optional(),
    shippingPrice: __1.MoneySchema.optional(),
    shippingTax: __1.MoneySchema.optional(),
    title: __1.ShortStringSchema,
    sku: __1.ShortStringSchema.optional(),
    optionMapping: zod_1.z.array(__1.ItemVariantOptionMapSchema).max(__1.MAX_ITEM_OPTION_VALUES).optional(),
    pictures: __1.PicturesSchema.optional(),
    promotion: __1.PromotionSchema.omit({ ads: true, items: true }).optional(),
    weight: __1.WeightSchema.optional(),
});
const BaseOrderItemChangeSchema = zod_1.z.object({
    itemId: __1.ShortStringSchema,
    currentQuantityOrdered: zod_1.z.number().optional(),
    previousQuantityOrdered: zod_1.z.number().optional(),
    variantId: __1.ShortStringSchema.optional(),
});
exports.OrderItemChangeSchema = zod_1.z.discriminatedUnion('changeType', [
    BaseOrderItemChangeSchema.extend({
        changeType: zod_1.z.literal(__1.OrderItemChangeType.Added),
        currentQuantityOrdered: zod_1.z.number(),
    }),
    BaseOrderItemChangeSchema.extend({
        changeType: zod_1.z.literal(__1.OrderItemChangeType.Changed),
        currentQuantityOrdered: zod_1.z.number(),
        previousQuantityOrdered: zod_1.z.number(),
    }),
    BaseOrderItemChangeSchema.extend({
        changeType: zod_1.z.literal(__1.OrderItemChangeType.NotChanged),
    }),
    BaseOrderItemChangeSchema.extend({
        changeType: zod_1.z.literal(__1.OrderItemChangeType.Removed),
        previousQuantityOrdered: zod_1.z.number(),
    }),
]);
exports.OrderItemsChangeSchema = zod_1.z.array(exports.OrderItemChangeSchema);
//# sourceMappingURL=order-item.js.map